// extracted by mini-css-extract-plugin
export default {"cardsControls":"cardControls_cardsControls__-RNBy","cardsCount":"cardControls_cardsCount__Qv2vT"};